var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.window.width>480 ? 'font-size:12px;' : 'font-size:10px;')},[(
      _vm.sondage_data_resultats[_vm.questionId] !== undefined &&
        _vm.sondage_data_resultats[_vm.questionId].element_type !== 'checkboxes' &&
        _vm.sondage_data_resultats[_vm.questionId].element_type !== 'orderedChoices'
    )?_c('h3',{style:(_vm.type==='pie' ? 'text-align:center' : '')},[_vm._v("\n    "+_vm._s(_vm.sondage_data_resultats[_vm.questionId].donnees.resultats.reduce(
        function (a, b) { return a + b; },
        0
      ))+_vm._s(" ")+_vm._s(_vm.$tc(
        "results.nb.participant",
        _vm.sondage_data_resultats[_vm.questionId].donnees.resultats.reduce(
          function (a, b) { return a + b; },
          0
        ) > 1
      ))+"\n  ")]):_vm._e(),_vm._v(" "),(
      _vm.sondage_data_resultats[_vm.questionId] !== undefined &&
        _vm.sondage_data_resultats[_vm.questionId].element_type === 'checkboxes'
    )?_c('h3',{style:(_vm.type==='pie' ? 'text-align:center' : '')},[_vm._v("\n    "+_vm._s(_vm.sondage_data_resultats[_vm.questionId].nbParticipantsCheckboxes
        ? _vm.sondage_data_resultats[_vm.questionId].nbParticipantsCheckboxes
        : 0)+_vm._s(" ")+_vm._s(_vm.$tc(
        "results.nb.participant",
        _vm.sondage_data_resultats[_vm.questionId].nbParticipantsCheckboxes > 1
      ))+"\n  ")]):_vm._e(),_vm._v(" "),(
      _vm.sondage_data_resultats[_vm.questionId] !== undefined &&
        _vm.sondage_data_resultats[_vm.questionId].element_type === 'orderedChoices'
    )?_c('h3',{style:(_vm.type==='pie' ? 'text-align:center' : '')},[_vm._v("\n    "+_vm._s(_vm.sondage_data_resultats[_vm.questionId].nbParticipantsOrderedChoices
        ? _vm.sondage_data_resultats[_vm.questionId].nbParticipantsOrderedChoices
        : 0)+_vm._s(" ")+_vm._s(_vm.$tc(
        "results.nb.participant",
        _vm.sondage_data_resultats[_vm.questionId].nbParticipantsOrderedChoices > 1
      ))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59880330","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultats/section/SectionTitleOthers.vue
// module id = null
// module chunks = 